import {
  FaCertificate,
  FaLightbulb,
  FaComments,
  FaHeart,
  FaHamburger,
  FaCocktail,
  FaLeaf,
  FaCamera,
} from "react-icons/fa";


export const ProjectData = [
  {
    id: 1,
    category: "SafeMac Packs",
    title: "Engineered thermocol packaging for secure and stable transport of machinery parts.",
    description:
      "SafeMac Packs are purpose-built thermocol packaging solutions crafted to provide maximum cushioning and protection for heavy and sensitive machinery components during transit. These packs minimize vibration, absorb shocks from handling, and ensure items remain secure, reducing risk of operational damage or misalignment. Ideal for industrial-grade equipment, they enhance both safety and handling efficiency.",
    image: "Machinery.webp",
  },
  {
    id: 2,
    category: "ObjecSaf Inserts",
    title: "Thermocol compartments for organized storage and shock absorption of sensitive items.",
    description:
      "ObjecSaf Inserts are custom-cut thermocol dividers and holders designed to separate and secure delicate items inside boxes. They offer superior impact resistance and organization, making them ideal for electronics, glassware, handicrafts, or decorations. Each insert can be tailored to item shape, reducing friction and preventing movement, ensuring item integrity throughout transport and storage.",
    image: "Decorations.webp",
  },
  {
    id: 3,
    category: "CamSaf Packaging",
    title: "Precision-cut thermocol boxes tailored for camera, assets, and lens protection.",
    description:
      "CamSaf Packaging provides tailored thermocol enclosures specially designed for cameras, lenses, drones, and other fragile tech assets. The material absorbs shocks and vibrations, while the custom-fit cavities prevent motion during shipping. Its lightweight design ensures easy portability, making it perfect for both professional photographers and equipment suppliers.",
    image: "CamSaf.webp",
  },
  {
    id: 4,
    category: "AssetShiel Cases",
    title: "Durable thermocol boxes designed to safeguard valuable assets during storage or transit.",
    description:
      "AssetShiel Cases are engineered with durable thermocol materials to deliver reliable protection for expensive or critical assets. These cases offer excellent insulation, impact resistance, and stacking strength, making them suitable for shipping tools, instruments, industrial goods, and electronics. With customizable internal designs, each case maximizes security for your assets.",
    image: "Insulation.webp",
  },
  {
    id: 5,
    category: "VoidFill Protectors",
    title: "Thermocol fillers designed to cushion and stabilize products inside packaging.",
    description:
      "VoidFill Protectors are space-filling thermocol inserts used in packages to prevent product shifting and reduce damage risk. Lightweight and easy to use, they absorb impact from external shocks and fill gaps around irregularly shaped products. These are perfect for fragile shipments, reducing returns due to breakage and enhancing product presentation.",
    image: "Lightweight.webp",
  },
  {
    id: 6,
    category: "CeiloWra Panels",
    title: "Lightweight thermocol ceiling sheets offering thermal insulation and easy installation.",
    description:
      "CeiloWra Panels are thermocol-based ceiling sheets designed for thermal insulation and visual enhancement of interior spaces. Ideal for residential, commercial, or temporary structures, these panels reduce heat transfer, save energy, and are extremely lightweight for effortless installation. They also offer resistance to moisture and pests, increasing longevity.",
    image: "Ceilings.webp",
  },
  {
    id: 7,
    category: "EchoShield Thermocol",
    title: "Specialized thermocol panels made to absorb and reduce noise, for acoustic insulation in studios.",
    description:
      "EchoShield Thermocol panels are specially engineered to provide acoustic insulation for environments like music studios, offices, or auditoriums. They dampen sound, reduce echo, and control vibration through their dense cellular structure. These lightweight panels are easy to install and offer an affordable solution to create quiet, sound-controlled spaces.",
    image: "EchoShield.webp",
  },
  {
    id: 8,
    category: "Medicine Box",
    title: "Thermocol boxes designed for safe and temperature-controlled transportation of pharmaceutical products and vaccines.",
    description:
      "Medicine Boxes are high-grade thermocol containers that maintain temperature-sensitive pharmaceuticals like vaccines, insulin, and biologics. They are insulated to preserve cold chain integrity and are moisture-resistant to prevent contamination. Lightweight and reusable, these boxes are trusted for hospitals, pharmacies, and medical logistics.",
    image: "Medicines.webp",
  },
];

export const featureCards = [
  {
    icon: <FaCertificate className="mx-auto text-4xl" />,
    title: "Our Vision",
    description:
      "To lead the way in sustainable thermocol packaging solutions, providing eco-friendly alternatives that combine innovation with high-performance protection for a variety of products.",
  },
  {
    icon: <FaLightbulb className="mx-auto text-4xl" />,
    title: "Our Mission",
    description:
      "To revolutionize the packaging industry by embracing sustainability and continuous innovation in thermocol production, reducing, while ensuring superior protection and insulation for every product we deliver.",
  },
  {
    icon: <FaComments className="mx-auto text-4xl" />,
    title: "Extraordinary Quality",
    description:
      "Our thermocol packaging solutions are crafted to offer outstanding durability, insulation, ensuring your products remain secure and eco-friendly throughout their journey.",
  },
];

export const OfferData = [
  {
    icon: <FaHeart />,
    title: "Health & Beauty Packaging",
    desc: "Precision-cut thermocol inserts ensure safe delivery of fragile health and beauty products like glass bottles, jars, and ampoules by minimizing impact and breakage during transit.",
  },
  {
    icon: <FaHamburger />,
    title: "Food Packaging",
    desc: "Our thermocol containers offer excellent insulation to maintain the temperature and freshness of perishable food items, ideal for hot and cold food delivery solutions.",
  },
  {
    icon: <FaCocktail />,
    title: "Beverage Packaging",
    desc: "Thermocol bottle holders and boxes provide cushioning for beverages, protecting glass and PET bottles from shock, while maintaining optimal temperature during shipping.",
  },
  {
    icon: <FaLeaf />,
    title: "Cosmetics Packaging",
    desc: "Specially molded thermocol trays safeguard delicate cosmetic products, offering a premium unboxing experience while preventing spills, scratches, or breakage.",
  },
  // {
  //   icon: <FaSprayCan />,
  //   title: "Decorating and Labeling",
  //   desc: "Thermocol packaging solutions add aesthetic appeal with customizable shapes and branding, making your labeled products stand out while staying securely packed.",
  // },

  {
    icon: <FaCamera />,

    title: "Camera Packaging",

    desc: "Custom-designed thermocol boxes provide shock-absorbent compartments for camera bodies and lenses, ensuring maximum protection from impact, dust, and vibration during transport or storage.",
  },
];

export const Industries = [
  {
    category: "Electronics Packaging",
    slug: "electronic",
    items: [
      {
        img: "Television.webp",
        title: "Television",
        desc: "Our custom thermocol packaging for televisions is engineered to absorb impact, prevent scratches, and protect fragile screens during transit or storage. Whether for LED, LCD, or smart TVs, we ensure maximum cushioning and support to eliminate damage risk.",
      },
      {
        img: "Computers.webp",
        title: "Computers",
        desc: "Our thermocol packaging for computers offers superior shock absorption, anti-static protection, and secure housing for desktops, CPUs, and all-in-one systems. Designed to fit snugly around components, it minimizes movement and impact during transit.",
      },
      {
        img: "washing.webp",
        title: "Washing Machine",
        desc: "Heavy-duty thermocol molds cradle washing machines from all sides, preventing movement and absorbing transport impacts. Designed to support the drum and outer body, the structure ensures vibration resistance and maintains the integrity of delicate electronics and mechanisms.",
      },
      {
        img: "fridge.webp",
        title: "Fridge",
        desc: "Custom thermocol panels for refrigerators offer firm side, top, and base protection, safeguarding the appliance’s corners, coils, and compressor during handling. Molded to fit various fridge sizes, it resists deformation, minimizes vibrations, and enhances stability during transport.",
      },
      {
        img: "ac.webp",
        title: "Air Condition",
        desc: "Designed for indoor and outdoor AC units, the thermocol packaging locks in critical parts like the compressor, fins, and control modules. Its structural integrity ensures secure placement, thermal insulation, and shock absorption to prevent mechanical damage.",
      },
      {
        img: "HomeAppliances.webp",
        title: "Microwave",
        desc: "Precision-molded thermocol for microwaves ensures the glass turntable and internal electronics remain stationary and protected. It cushions the microwave against external impact and vibration, especially around the door and display panel, ensuring damage-free delivery.",
      },
    ],
  },
  {
    category: "Food Packaging",
    slug: "food",
    items: [
      {
        img: "Seafood.webp",
        title: "Seafood",
        desc: "Our thermocol packaging for seafood is specially crafted to maintain temperature, prevent contamination, and ensure the freshness of your catch throughout transportation. Whether for fish, shrimp, or shellfish, our insulated boxes deliver consistent cold-chain performance.",
      },
      {
        img: "Fruits.jpg",
        title: "Fruits & Vegetables",
        desc: "Our thermocol packaging for fruits and vegetables is designed to preserve freshness, prevent bruising, and maintain optimal temperature during transit. Whether it's delicate berries or bulk produce, our boxes offer superior cushioning and ventilation.",
      },
      {
        img: "Perishable1.jpg",
        title: "Perishable Food Items",
        desc: "Our thermocol packaging for perishables is built to maintain cold chain integrity, extend shelf life, and ensure that temperature-sensitive goods like dairy, meats, and baked items arrive fresh and intact. Whether for local delivery or long-distance shipping, our solutions provide maximum insulation and hygiene.",
      },
    ],
  },
  {
    category: "Pharmaceutical Packaging",
    slug: "pharmaceutical",
    items: [
      {
        img: "Vaccines.webp",
        title: "Vaccines",
        desc: "Our thermocol packaging for vaccines ensures strict temperature control, contamination prevention, and shock protection—essential for preserving the efficacy of temperature-sensitive medical products. Ideal for hospitals, labs, and cold chain logistics providers.",
      },
      {
        img: "Medicines.webp",
        title: "Medicines",
        desc: "Our thermocol packaging solutions for medicines are designed to maintain product integrity by controlling temperature, reducing shock, and preventing contamination. Whether tablets, injectables, or sensitive formulations, we ensure secure delivery from manufacturer to patient.",
      },
      {
        img: "Biological.webp",
        title: "Biological Samples",
        desc: "Our thermocol packaging solutions for biological products are engineered to protect integrity by maintaining critical temperature ranges, minimizing shock, and preventing contamination. Whether transporting samples, cultures, or reagents, we deliver uncompromised safety from lab to lab.",
      },
    ],
  },
  {
    category: "Industrial Packaging",
    slug: "industrial",
    items: [
      {
        img: "Machinery.webp",
        title: "Machinery Parts",
        desc: "Our packaging solutions for machinery parts are meticulously designed to ensure the safe transport and storage of sensitive components, while maintaining their integrity during transit. From gears to electrical components, we deliver reliable protection from vibrations, impacts, and environmental factors.",
      },
      {
        img: "Glassware.webp",
        title: "Glassware",
        desc: "Our packaging solutions for glassware are engineered to ensure the safe handling and transport of delicate glass items, preventing breakage, chipping, or contamination. Whether you're shipping laboratory glass, scientific equipment, or decorative glass items, we guarantee safe, secure transit from point A to point B.",
      },
      {
        img: "auto.webp",
        title: "Automotive Components",
        desc: "Our packaging solutions for automotive components are specifically designed to protect and preserve the integrity of essential car parts during transit. From engines and transmission parts to sensors and electrical components, we ensure each item is safely secured to withstand the rigors of transport, minimizing risk of damage, corrosion, or contamination.",
      },
      {
        img: "Yarn.webp",
        title: "Yarn Packaging",
        desc: "Our packaging solutions for yarn are designed to protect the quality and texture of yarns during storage and transit. Whether it’s cotton, wool, or synthetic fibers, we ensure that each skein, spool, or cone is safely contained to prevent tangling, damage, or contamination, while preserving its quality and appearance.",
      },
    ],
  },
  {
    category: "Construction Industry",
    slug: "construction",
    items: [
      {
        img: "Ceilings.webp",
        title: "Ceilings & Partitions",
        desc: "Our packaging solutions for ceilings and partition materials are designed to protect large, fragile components during transportation and installation. From drywall to acoustic panels and suspended ceilings, we ensure that each item is securely packaged to prevent damage, scratching, or bending, while also maintaining ease of handling and installation.",
      },
      {
        img: "Lightweight.webp",
        title: "Lightweight Fillers",
        desc: "Our packaging solutions for lightweight fillers are designed to protect the material integrity during transport and storage. Whether for construction, manufacturing, or insulation purposes, we ensure that these delicate materials, such as foam or aerated fillers, are securely contained to prevent compression, contamination, or damage, while maintaining their optimal performance.",
      },
      {
        img: "Insulation.webp",
        title: "Insulation",
        desc: "Our packaging solutions for insulation materials are designed to protect the integrity and performance of thermal, acoustic, and fire-resistant insulation during storage and transportation. Whether it’s fiberglass, foam boards, or spray foam, we ensure that each product is safely secured to prevent damage, moisture absorption, and contamination, while maintaining its insulating properties.",
      },
    ],
  },
  {
    category: "Decorative & Event",
    slug: "decorative-event",
    items: [
      {
        img: "Props.webp",
        title: "Props",
        desc: "Our packaging solutions for event decorations are designed to ensure the safe transport and storage of fragile and intricate items used in events, from floral arrangements and centerpieces to drapery and lighting fixtures. We guarantee that each piece is carefully secured to prevent breakage, wrinkles, or damage, ensuring that your décor arrives in perfect condition, ready to impress.",
      },
      {
        img: "Decorations.webp",
        title: "Decorations",
        desc: "Our packaging solutions for decorative items are meticulously designed to ensure safe transport and storage of fragile and delicate decorations. Whether it's holiday ornaments, wall art, or handcrafted pieces, we ensure that each item is securely packaged to prevent breakage, scratching, or discoloration, preserving the beauty and quality of your decorations.",
      },
      {
        img: "decoration.webp",
        title: "Stage Designs",
        desc: "Our packaging solutions for stage design components are specifically crafted to protect intricate and oversized elements, ensuring they arrive in perfect condition for events, theater productions, or concerts. From backdrops and props to set pieces and lighting fixtures, we provide secure packaging to prevent damage, scratches, or warping during transit.",
      },
    ],
  },
];

export const IndustryTitles = [
  {
    slug: "electronic",
    title:
      "Precision protection for delicate electronics — secure, shock-resistant, and custom-fit.",
  },
  {
    slug: "food",
    title:
      "Freshness preserved with insulated thermocol — ideal for seafood, produce, and perishables.",
  },
  {
    slug: "pharmaceutical",
    title:
      "Reliable cold-chain and contamination-free packaging for medical and biological products.",
  },
  {
    slug: "industrial",
    title:
      "Robust packaging solutions for machinery, automotive parts, glassware, and more.",
  },
  {
    slug: "construction",
    title:
      "Lightweight, durable packaging for insulation, ceilings, and building materials.",
  },
  {
    slug: "decorative-event",
    title:
      "Custom packaging for props, decorations, and stage designs — safe and presentation-ready.",
  },
];
